import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowLeft, ReceiptText } from "lucide-react";
import { getListDateLocale } from "../utils/dateLocale";
const FORMAT = {
  day: "2-digit",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
};
export default function MyEntriesPage({
  handleBackToMain,
  totalEntriesCount,
  isLoadingEntries,
  entryHistory,
  entryHistoryLoadError,
  loadEntryHistory,
}) {
  const { t } = useTranslation();
  const describe = (item) =>
    item.descriptionKey
      ? t(item.descriptionKey, {
          reward: item.rewardLabelKey
            ? t(item.rewardLabelKey)
            : item.rewardLabel,
        })
      : item.description;
  return (
    <div className="shake-list-page">
      <div className="shake-list-heading">
        <button
          className="shake-icon-button"
          aria-label={t("common.backToMain")}
          onClick={handleBackToMain}
        >
          <ArrowLeft size={22} />
        </button>
        <h1>{t("main.myEntries")}</h1>
      </div>
      <div className="shake-total">
        <span>{t("entries.total")}</span>
        <strong>{totalEntriesCount}</strong>
        <img src={`${process.env.PUBLIC_URL}/images/game/coin.webp`} alt="" />
      </div>
      <div className="shake-list">
        {isLoadingEntries ? (
          <div
            className="shake-list-skeleton"
            role="status"
            aria-label={t("entries.loading")}
          >
            <div className="ui-skeleton" />
            <div className="ui-skeleton" />
            <div className="ui-skeleton" />
          </div>
        ) : entryHistoryLoadError ? (
          <div className="shake-empty" role="alert">
            <p>{t("entries.loadFailed")}</p>
            <button
              className="join-shake-btn shake-secondary-button"
              onClick={() => loadEntryHistory()}
            >
              {t("common.retry")}
            </button>
          </div>
        ) : entryHistory.length ? (
          entryHistory.map((item) => (
            <div className="shake-list-row" key={item.id}>
              <div className="shake-row-icon">
                <ReceiptText size={21} />
              </div>
              <div className="shake-row-content">
                <strong>{describe(item)}</strong>
                <span>
                  {item.date
                    ? new Date(item.date).toLocaleDateString(
                        getListDateLocale(),
                        FORMAT,
                      )
                    : t("entries.dateUnavailable")}
                </span>
              </div>
              <b className={item.type === "gain" ? "positive" : ""}>
                {item.type === "gain" ? "+" : "-"}
                {t("entries.amount", { count: item.amount })}
              </b>
            </div>
          ))
        ) : (
          <div className="shake-empty">
            <div className="shake-modal-icon">
              <ReceiptText size={28} />
            </div>
            <strong>{t("entries.emptyTitle")}</strong>
            <p>{t("entries.emptyBody")}</p>
          </div>
        )}
      </div>
    </div>
  );
}
